var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdyenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 35,
    viewBox: "0 0 100 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34.4444,
    fill: "url(#pattern0_6718_2009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6718_2009",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6718_2009",
    transform: "scale(0.00555556 0.016129)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6718_2009",
    width: 180,
    height: 62,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAA+CAMAAAC1OMG+AAAAM1BMVEX///81tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFQ1tFTAqnYAAAAAEXRSTlMAYIBAv/9wIDCfEI/P71Cv3xTYSZMAAAF2SURBVHgB7dkHbgMhEIVhGJjtC9z/sull7dnynCACyjx19Mt8VnNZo6t9ljZzjaA9b0aKVrSiFa1oeIpWtKLpaF2/zYbu49hJtPwKdXAC3HXc2I2HjzdOn9Hkt0SJxk+ONk/GXDcAmpePql85P1redd0gaJ7F28+JFncBDYDm/jUZuASaJ6gB0PY1oTLoADQWQVNBNNQ0jKa7xUJoT0SeH2/2FzOg0ZMENAuCpiJo/IRyoenP0f28iKh2tF2ZW0M75krQHY5O1aAHGB24FnQyMJqqQYcG0dY0h46DaQMt9o/QHiCOAHoG0HMuNM/OuVFEF40EMb00y3mzkrvbD9FyhDb+942ioWYGmpgLPQCXBaCxQNPlQMvqbTJKeZppzYUe1msQ0ji+bkIutBmWy8vMkK4bBzRhzYF+mx390ewDzXTb3PhINHJvwSxe2YoTfVqg6BIb/P3W+tGO5RSNTdG2RXTfIHo07aGXqT30WKnZ9MBz77amewYJcV5CpmDdXQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyenLogo);
export default __webpack_public_path__ + "static/media/AdyenLogo.c930d5f7569ad39096911bfba9061730.svg";
export { ForwardRef as ReactComponent };